import { useLocalStorage } from "@mantine/hooks";

export const rememberDeviceLocalStorageKey = "vcg-remember-device";
export function useRememberDeviceState() {
	return useLocalStorage({
		key: rememberDeviceLocalStorageKey,
		defaultValue: true,
		deserialize: (value) => value === "true",
		serialize: (value) => value.toString(),
	});
}
